import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-signing', 'TITLE', 'Digital signing');
Labels.set(
    'ui-signing',
    'DIGIPASS_CHALLENGE',
    'Enter this code in your PIN calculator to sign:'
);
Labels.set('ui-signing', 'DIGIPASS_PASSWORD', 'Enter code from PIN calculator');
Labels.set('ui-signing', 'DIGIPASS_PLACEHOLDER', '');
Labels.set('ui-signing', 'DIGIPASS_CONFIRM', 'Confirm');
Labels.set(
    'ui-signing',
    'DIGIPASS_ERROR_MESSAGE',
    'Confirming with PIN calculator failed.'
);

Labels.set(
    'ui-signing',
    'SMART_ID_RUNNING',
    'Sign with Smart-ID. Compare the code!'
);
Labels.set('ui-signing', 'SMART_ID_CHALLENGE', 'Your verification code:');
Labels.set(
    'ui-signing',
    'SMART_ID_INTRO_MESSAGE',
    'Make sure that you agree with the information you sign. If unsure, return to the previous step and check the document.'
);
Labels.set('ui-signing', 'SMART_ID_EXPLANATION', '');
Labels.set(
    'ui-signing',
    'SMART_ID_SENDING_MESSAGE',
    'Request is sent to your device. Compare the code and enter PIN2.'
);

Labels.set(
    'ui-signing',
    'MOBILE_ID_RUNNING',
    'Sign with Mobile-ID. Compare the code!'
);
Labels.set('ui-signing', 'MOBILE_ID_CHALLENGE', 'Your verification code:');
Labels.set(
    'ui-signing',
    'MOBILE_ID_INTRO_MESSAGE',
    'Make sure that you agree with the information you sign. If unsure, return to the previous step and check the document.'
);
Labels.set('ui-signing', 'MOBILE_ID_EXPLANATION', '');
Labels.set(
    'ui-signing',
    'MOBILE_ID_SENDING_MESSAGE',
    'Request is sent to your device. Compare the code and enter PIN2.'
);

Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_RUNNING',
    'Sign with eParaksts mobile. Compare the code!'
);
Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_CHALLENGE',
    'Your verification code:'
);
Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_INTRO_MESSAGE',
    'Make sure that you agree with the information you sign. If unsure, return to the previous step and check the document.'
);
Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_EXPLANATION',
    'Always compare this verification code with the one requested in eParaksts mobile. In order to sign, open eParaksts mobile app and enter PIN2.'
);
Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_SENDING_MESSAGE',
    'Request is sent to your device. Compare the code and enter PIN2.'
);
Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_ERROR_MESSAGE',
    'Signing with eParaksts mobile failed.'
);

Labels.set(
    'ui-signing',
    'SIMPLE_ID_RUNNING',
    'Approve with biometrics or PIN. Compare the code!'
);
Labels.set('ui-signing', 'SIMPLE_ID_CHALLENGE', 'Your verification code:');
Labels.set(
    'ui-signing',
    'SIMPLE_ID_INTRO_MESSAGE',
    'Make sure that you agree with the information you approve. If unsure, return to the previous step and check the document.'
);
Labels.set('ui-signing', 'SIMPLE_ID_EXPLANATION', '');
Labels.set(
    'ui-signing',
    'SIMPLE_ID_SENDING_MESSAGE',
    'Request is sent to your device. Compare the code and approve with biometrics or PIN.'
);

Labels.set('ui-signing', 'CANCEL_BUTTON_LABEL', 'Back');
Labels.set('ui-signing', 'CONFIRM_BUTTON_LABEL', 'Confirm');

Labels.set(
    'ui-signing',
    'SMART_ID_ERROR_MESSAGE',
    'Signing with Smart-ID failed.'
);
Labels.set(
    'ui-signing',
    'MOBILE_ID_ERROR_MESSAGE',
    'Signing with Mobile-ID failed.'
);
Labels.set(
    'ui-signing',
    'SIMPLE_ID_ERROR_MESSAGE',
    'Confirming with biometrics or PIN failed.'
);
Labels.set(
    'ui-signing',
    'CERTIFICATE_ERROR_MESSAGE',
    'Signing with ID card failed.'
);

Labels.set('ui-signing', 'SMART_ID_BUTTON_LABEL', 'Sign with Smart-ID PIN2');
Labels.set('ui-signing', 'MOBILE_ID_BUTTON_LABEL', 'Sign with Mobile-ID PIN2');
Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_BUTTON_LABEL',
    'Sign with eParaksts mobile'
);
Labels.set(
    'ui-signing',
    'SIMPLE_ID_BUTTON_LABEL',
    'Confirm with biometrics or PIN'
);
Labels.set('ui-signing', 'CERTIFICATE_BUTTON_LABEL', 'Sign with ID-card PIN2');
Labels.set('ui-signing', 'DIGIPASS_BUTTON_LABEL', 'Confirm');

Labels.set(
    'ui-signing',
    'HWCRYPTO_DEFAULT_ERROR',
    'ID-card plugin does not work. Restart your browser and try again. {{info-link}}'
);
Labels.set(
    'ui-signing',
    'HWCRYPTO_NO_CERTIFICATES',
    'No valid ID-card certificate was found. Remove ID-card from the reader, insert it back and try again. {{info-link}}'
);
Labels.set(
    'ui-signing',
    'HWCRYPTO_USER_CANCEL',
    'Signing attempt was terminated, because you clicked "Cancel".'
);
Labels.set(
    'ui-signing',
    'HWCRYPTO_DRIVER_ERROR',
    'ID-card software error occurred. Check if the ID-card software is up to date, if not - update it, restart browser and try again. {{info-link}}'
);
Labels.set(
    'ui-signing',
    'HWCRYPTO_NO_IMPLEMENTATION',
    'ID-card plugin error occurred. Check if the ID-card software is up to date and plugin Web eID or "eParaksts signing extension" in your browser is enabled. Then  Restart your browser and try again.'
);

Labels.set('ui-signing', 'LINK_PLACEHOLDER', 'Read more about ID-card');
